import { Helmet } from "react-helmet-async";

const SITE = "https://ezbuildabot.com";

export default function Seo({
    title,
    description,
    path = "/",
    image = `${SITE}/og-image.jpg`,
}) {
    const fullTitle = title
        ? `${title} · ezBuildABot`
        : "ezBuildABot — Custom AI Agents, Built ez.";
    const url = `${SITE}${path}`;
    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}
